module.exports = __webpack_public_path__ + "static/WpK_salon_pakiet_srebrny-3edc786647a49e802224f12891acf9cf.jpg";